<template>
  <div>
    <v-col sm="12" md="12" lg="12">
      <div v-if="field.tooltip != ''">
        <v-switch
          color="#3b4256"
          v-model="field.value"
          :label="field.label"
          hide-details
          :readonly="field.readonly"
          prepend-icon="info"
        >
          <v-tooltip v-if="field.tooltip != ''" bottom slot="prepend">
            <template v-slot:activator="{ on }">
              <v-icon v-on="on" color="#3b4256">
                info
              </v-icon>
            </template>
            <span>{{ field.tooltip }}</span>
          </v-tooltip>
        </v-switch>
      </div>
      <div v-else>
        <v-switch
          color="#3b4256"
          v-model="field.value"
          :label="field.label"
          hide-details
          :readonly="field.readonly"
        >
        </v-switch>
      </div>
    </v-col>
  </div>
</template>

<script>
export default {
  name: 'iol-switch',
  props: ['fields'],
  data() {
    return {
      field: this.fields,
    }
  },
  created() {
    this.$emit('fields', this.field)
  },
}
</script>

<style></style>
